import React, { useEffect, useRef, useState } from 'react'
import { BottomNavigation, BottomNavigationAction } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useUser } from '../../context/UserContext'
import AktualIcon from '../../icons/AktualIcon'
import LoyaltyIcon from '../../icons/LoyaltyIcon'
import HistoryIcon from '../../icons/HistoryIcon'
import './NavBar.css'

const NavBar = () => {
  const navigate = useNavigate()
  const { userInfo, setUserInfo } = useUser()
  const [value, setValue] = useState(0)
  const lastFetchRef = useRef(0)

  const fetchUserInfo = async () => {
    const token = localStorage.getItem('token')
    if (!token) return
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/loyalty/get-user`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      const json = await response.json()
      if (json.success) {
        setUserInfo(json.data)
      }
      console.log('User info:', json)
    } catch (error) {
      console.error('Error fetching user info:', error)
    }
  }

  useEffect(() => {
    const handleUserActivity = () => {
      const now = Date.now()
      if (now - lastFetchRef.current < 7000) return
      lastFetchRef.current = now
      fetchUserInfo()
    }

    window.addEventListener('click', handleUserActivity)
    window.addEventListener('touchstart', handleUserActivity)

    return () => {
      window.removeEventListener('click', handleUserActivity)
      window.removeEventListener('touchstart', handleUserActivity)
    }
  }, [])

  const handleNavigation = newValue => {
    setValue(newValue)
    switch (newValue) {
      case 0:
        navigate('/')
        break
      case 1: {
        const token = localStorage.getItem('token')
        const orderId = localStorage.getItem('auth_orderId')

        if (token) {
          if (window.location.pathname === '/restauracji') {
          } else {
            navigate('/restauracji')
          }
        } else {
          if (orderId) {
            navigate('/register')
          } else {
            navigate('/login')
          }
        }
        break
      }
      case 2: {
        const token = localStorage.getItem('token')
        const orderId = localStorage.getItem('auth_orderId')

        if (token) {
          navigate('/history')
        } else {
          if (orderId) {
            navigate('/register')
          } else {
            navigate('/login')
          }
        }
        break
      }
      default:
        break
    }
  }

  return (
    <BottomNavigation
      value={value}
      onChange={(event, newValue) => handleNavigation(newValue)}
      showLabels
      className='navbar-bottom'
    >
      <BottomNavigationAction label='Aktualne zamówienie' icon={<AktualIcon />} />
      <BottomNavigationAction label='Program lojalnościowy' icon={<LoyaltyIcon />} />
      <BottomNavigationAction label='Historia zamówień' icon={<HistoryIcon />} />
    </BottomNavigation>
  )
}

export default NavBar
